import { EXTEND_SKU } from '@/data/constants'
import type { StandardLineItem } from '@/types/ShopFront/CheckoutStandards'

export const getWarrantyId = ({ lineItems, id }: { lineItems: StandardLineItem[], id: string }) => {
  const sku = lineItems.find((item) => item.id === id)?.sku || ''
  const warrantySku = `${EXTEND_SKU}${sku}`
  const warrantyProduct = lineItems.find((item) => item.sku.includes(warrantySku))
  return warrantyProduct?.id || null
}

export default getWarrantyId
